import React, { Component } from "react";
import Button from "@material-ui/core/Button";

import { withRouter } from "react-router";
import { changeLanguage } from "../../../store/actions";
import { connect } from "react-redux";
import { Animated } from "react-animated-css";
import MyLocationIcon from "@material-ui/icons/MyLocation";
import PersonIcon from "@material-ui/icons/Person";

class index extends Component {
  state = {
    showNavBar: false,
    showBorderBottom: true,
  };

  componentDidMount = () => {
    window.addEventListener("scroll", this.handleScroll);
    this.props.homePage
      ? this.setState({ showNavBar: false, showBorderBottom: false })
      : this.setState({ showNavBar: true, showBorderBottom: true });
  };

  componentWillUnmount = () => {
    window.removeEventListener("scroll", this.handleScroll);
  };

  handleScroll = () => {
    if (this.props.homePage) {
      const rect = this.props.appRef.current.getBoundingClientRect();
      const storeInfoRect =
        this.props.storeInfoRef.current.getBoundingClientRect();
      if (storeInfoRect.y < -20) {
        this.setState({ showStoreLogoHeader: true });
      } else {
        this.setState({ showStoreLogoHeader: false });
      }
      if (rect.y < 0) {
        this.setState({ showNavBar: true, showBorderBottom: true });
      } else if (rect.y == 0) {
        this.setState({ showNavBar: false, showBorderBottom: false });
      }
    } else {
      this.setState({ showNavBar: true, showBorderBottom: true });
    }
  };

  render() {
    let ios =
      !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
    let insta = navigator.userAgent.match(/instagram/i);
    insta = false;
    const { settings } = this.props;
    const showBannerB2B = () => {
      if (this.props.distributorBannerOverride) {
        return this.props.distributorEnableBanner && !this.props.isNotificationDismissedB2B;
      } else {
        return (
          this.props.settings.enable_banner_b2b &&
          !this.props.isNotificationDismissedB2B
        );
      }
    };

    const languageAction = (
      <Button
        className="back_arrow mt-1 languageMakeDisappearForLargeScreen"
        onClick={() => {
          this.props.changeLanguage();
          window.scrollBy(0, 1);
          window.scrollBy(0, -1);
        }}
        style={{
          float: this.props.language == "english" ? "right" : "left",
          height: "50px",
          marginRight: this.props.language == "english" ? "10px" : 0,
          marginLeft: this.props.language == "arabic" ? "10px" : 0,
          fontSize: 20,
          paddingBottom: 15,
          color:
            this.props.homePage && !this.state.showNavBar ? "white" : "black",
          display: "inline",
          fontFamily: this.props.language == "arabic" && "Quicksand",
        }}
      >
        {this.props.language == "english" ? "ع" : "En"}
      </Button>
    );

    const profileAction = (
      <Button
        className=" mt-1"
        onClick={() => {
          this.props.setB2BProfileOpen(!this.props.b2bProfileOpen);
        }}
        style={{
          float: this.props.language == "english" ? "right" : "left",

          height: "50px",
          maxWidth: "30px",
          display: "inline-block",
          lineHeight: this.props.language == "english" ? 3.5 : 3,
          paddingRight: this.props.language == "english" && 20,
          paddingLeft: this.props.language == "arabic" && 20,
        }}
      >
        <PersonIcon
          style={{
            color:
              this.props.homePage && !this.state.showNavBar ? "white" : "black",
          }}
        />
      </Button>
    );

    const historyAction =
      this.props.homePage == true ? (
        <Button
          className=" mt-1"
          onClick={() => {
            this.props.history.push("/distributor/track/order");
          }}
          style={{
            float: this.props.language == "english" ? "right" : "left",

            height: "50px",
            maxWidth: "30px",
            display: "inline-block",
            lineHeight: this.props.language == "english" ? 3.5 : 3,
            paddingRight: this.props.language == "english" && 20,
            paddingLeft: this.props.language == "arabic" && 20,
          }}
        >
          <MyLocationIcon
            style={{
              color:
                this.props.homePage && !this.state.showNavBar
                  ? "white"
                  : "black",
            }}
          />
        </Button>
      ) : null;
    return (
      <>
        {ios && insta ? (
          <div
            className={`${
              this.state.showBorderBottom ? "border-bottom " : ""
            } w-100 `.concat(
              this.props.language == "english"
                ? "detail_header"
                : "detail_header_ar"
            )}
            style={{
              height: "43px",
              backgroundColor: "white",
              zIndex: 1000,
            }}
          >
            <img
              className="img-fluid mt-1 "
              src={this.props.logo}
              style={{
                borderRadius: 10,
                height: 35,
                width: 35,
                objectFit: "fill",
              }}
            />
          </div>
        ) : null}
        <div
          className={`${
            this.state.showBorderBottom ? "border-bottom " : ""
          } w-100 `.concat(
            this.props.language == "english"
              ? "detail_header"
              : "detail_header_ar"
          )}
          style={{
            top: ios && insta ? "43px" : showBannerB2B() ? "50px" : "0px", /// for insta
            backgroundImage:
              this.state.showNavBar == false && this.props.homePage
                ? "linear-gradient(rgba(0, 0, 0, 0.5), transparent)"
                : "none",
            backgroundColor:
              this.state.showNavBar == false && this.props.homePage
                ? "transparent"
                : "white",
            zIndex: 1000,
          }}
        >
          {this.props.homePage == true && this.state.showStoreLogoHeader && (
            <Animated
              classNames="d-none"
              animationIn="flipInY"
              animationOut="fadeOut"
              animationInDuration={2000}
              isVisible={true}
              style={{
                display: "inline",
                position: "absolute",
                width: 50,
                right: "50%",
                left: "43%",
              }}
            >
              <img
                className="img-fluid mt-2"
                src={this.props.logo}
                style={{
                  borderRadius: 10,
                  height: 38,
                  width: 38,
                  objectFit: "fill",
                }}
              />
            </Animated>
          )}

          {languageAction}
          {this.props.settings.enable_tracking ? historyAction : null}
          {settings.enable_b2b_on_credit_payments &&
          this.props.shouldShowUserButton
            ? profileAction
            : null}
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    settings: state.store.store.settings,
    shouldShowUserButton: state.b2b.shouldShowUserButton,
    b2bProfileOpen: state.b2b.profileOpen,
    isNotificationDismissedB2B: state.b2b.isNotificationDismissedB2B,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    changeLanguage: () => dispatch(changeLanguage()),
    setB2BProfileOpen: (val) =>
      dispatch({ type: "SET_B2B_PROFILE_OPEN", payload: val }),
  };
};
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(index));
